import React from 'react'
import prod from '../public/images/product.jpg'
import {currencyFormat} from '../Functions'
import { useDispatch, useSelector } from 'react-redux'
import { add_item } from '../redux/slices/CartSlice'
import { change_product } from '../redux/slices/ProductSlice'
import { Link, useNavigate } from 'react-router-dom'
import { setErrorMessage, setSuccessMessage } from '../redux/slices/MessageSlice'
const Card = ({product}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {items,items_count,cart_total}=useSelector((state)=>state.CartReducer);

  const add_item_cart=(productCart)=>{
    console.log('productCart',productCart)
     if(productCart.quantity<=0){
      dispatch(setErrorMessage('غير متوفر الأن'));
          return;
      }
      let c=productCart.quantity;
      items.map((item)=>{
        if(item.product.id===productCart.id){
          c=c-item.quantity;
        }
      })
      if(c<=0){
        dispatch(setErrorMessage('غير متوفر الأن'));
        return;
      }
    dispatch(add_item({product:productCart,quantity:1,size:productCart.size?productCart.product_sizes[0]:''}))
    dispatch(setSuccessMessage('تم اضافة المنتج للسلة'));
  }
  
  // const product_select=(productSelect)=>{
  //   dispatch(change_product(productSelect));
  //   navigate('/product');
  // }
  return (
    <div  className="card product-card "  style={{ overflow:'hidden',width:'260px' ,cursor:'pointer'}}>
    <Link to={`/product/${product.id}`} style={{textDecoration:'none'}}> 
    <img className="card-img-top"  src={product.images} style={{ width:'100%',height:'420px' }} alt="Card image cap" />
    <div className="card-body product-body ">
        <h5 class="d-block text-truncate " >{product.name}</h5>
         <p class="d-block text-truncate">من {product.factory} | تاج</p>
        <p className='price d-block text-truncate'>{currencyFormat(product.price)} ج.م 
        {product.price_before&&<span> {currencyFormat(product.price_before)} ج.م</span>}
        </p>
    </div>
    {product.discount&& <div className='product-discount'>
      <p>{product.discount}%</p>
    </div>}
   </Link>
    <div className='product-bag' onClick={()=>add_item_cart(product)}>
    <i className="fa fa-cart-shopping "></i>
    </div>
  </div>

  )
}

export default Card
